import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { SheetItemComponentBase } from 'src/app/services/sheets-renderer.service';
import { Row } from 'src/app/types/aggregate-graph.types';
import { ItemContentComponent } from '../../item-content/item-content.component';

import { PhysioLevel, PhysiotherapyInstructions } from 'src/app/types/sheet-instruction.types';
import { InstructionBoxComponent } from '../../instruction-box/instruction-box.component';

@Component({
    selector: 'app-physiotherapy-item',
    templateUrl: './physiotherapy-item.component.html',
    styleUrl: './physiotherapy-item.component.scss',
    imports: [ItemContentComponent, InstructionBoxComponent],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class PhysiotherapyItemComponent implements SheetItemComponentBase {

	row!: Row;
	instructions!: PhysiotherapyInstructions;
	physioLevel!: string[];
    @Input() startLabel!: string;
    @Input() endLabel!: string;
	@Input('row') set updateRow(row: Row) {
		this.row = row;
		this.instructions = row.instructions as PhysiotherapyInstructions;
		this.physioLevel = Object.values(this.instructions).map(instruction => this.getPhysioLevel(instruction.physioLevel));
	}
	
	constructor() {
	}

	private getPhysioLevel(physioLevel: PhysioLevel | null) {
		switch (physioLevel) {
			case PhysioLevel.Active: return 'Level 1 Passive';
			case PhysioLevel.Passive: return 'Level 2 Active assisted';
			case PhysioLevel.Intensive:	return 'Level 3 Intensive';
			default: return '';
		}
	}
}